import {Autocomplete, Button, IconButton, Stack, TextField} from "@mui/material";
import {useEffect, useState} from "react";
import {FiTrash2} from "react-icons/fi";
import {rolesColumns} from "../../constants/dataGridColumns";
import useApiRequest from "../../hooks/useApiRequest";
import ListView from "../ListView/ListView";

const UserRolesGrid = ({userId}) => {
  const [isSettingNewRole, setIsSettingNewRole] = useState(false);
  const [selectedRoleId, setSelectedRoleId] = useState(null);
  const [rolesSelect, setRolesSelect] = useState([]);

  const {data, loading, list, remove, create} = useApiRequest(`/users/${userId}/roles`);

  const {data: dataRoles, loading: loadingRoles, list: listRoles} = useApiRequest(`/roles`);

  useEffect(() => {
    list();
    listRoles();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (rolesSelect.length === 0 && (dataRoles || data)) {
      const userRolesIds = data?.length > 0 ? data?.map((role) => role.id) : [];
      const rolesFiltered = dataRoles?.filter((role) => !userRolesIds.includes(role.id));
      const transformedList = rolesFiltered?.map((role) => ({
        id: role.id,
        label: role.name
      }));
      setRolesSelect(transformedList);
    }
  }, [dataRoles, data, rolesSelect]);

  const handleAccept = async () => {
    if (!selectedRoleId) return;
    const result = await create({role_id: selectedRoleId});

    if (result.success) {
      setRolesSelect((prev) => prev.filter((role) => role.id !== selectedRoleId));
    }
    listRoles();
    list();
    //setIsSettingNewRole(!isSettingNewRole);
  };

  const handleRoleSelect = (event, value) => {
    setSelectedRoleId(value?.id || null);
  };

  const handleRowDelete = async (id) => {
    try {
      await remove(id);
      list();
      listRoles();
    } catch (error) {
      console.error("Error al eliminar el registro:", error);
    }
  };

  const columns = [
    ...rolesColumns,
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <IconButton
            aria-label="delete"
            color="secondary"
            onClick={(e) => {
              e.stopPropagation();
              handleRowDelete(params.row.id);
            }}
          >
            <FiTrash2 />
          </IconButton>
        );
      }
    }
  ];

  return (
    <ListView
      viewTitle={"Roles"}
      columns={columns}
      data={data || []}
      loading={loading || loadingRoles}
      TopRigthButtons={
        <Stack direction="row" spacing={2}>
          {isSettingNewRole && (
            <Stack direction="row" spacing={2}>
              <Autocomplete
                disablePortal
                options={rolesSelect}
                sx={{width: 300}}
                onChange={handleRoleSelect}
                renderInput={(params) => <TextField {...params} label="Rol" />}
              />
              <Button variant="contained" onClick={handleAccept}>
                Aceptar
              </Button>
            </Stack>
          )}
          <Button
            variant="contained"
            color={isSettingNewRole ? "error" : "primary"}
            onClick={() => {
              setIsSettingNewRole(!isSettingNewRole);
            }}
          >
            {isSettingNewRole ? "Cancelar" : "Asignar rol"}
          </Button>
        </Stack>
      }
    />
  );
};

export default UserRolesGrid;
